import { render, staticRenderFns } from "./readyOrders.vue?vue&type=template&id=dff0c1d2&scoped=true&"
import script from "./readyOrders.vue?vue&type=script&lang=js&"
export * from "./readyOrders.vue?vue&type=script&lang=js&"
import style0 from "./readyOrders.vue?vue&type=style&index=0&id=dff0c1d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff0c1d2",
  null
  
)

export default component.exports